import { Buffer } from 'buffer'; 

interface IArgs {
  url: string;
  width?: number;
}

const extractFilename = (url) => {
  const regex = /([^/]+\.[a-zA-Z0-9]+)$/;
  const match = url?.match(regex);
  return match ? match[1] : null;
};

export const getOptimizedImage = ({ url, width }: IArgs) => {
  const cloudfrontUrl = 'https://d6r592j1mp8zt.cloudfront.net';
  const bucket = 'spectrumflow-image-handler-source';

  const key = extractFilename(url);

  const imageRequest = JSON.stringify({
    bucket,
    key,
    edits: {
      resize: {
        width: width,
      },
    },
  });

  const base64 = Buffer.from(imageRequest).toString('base64');

  const optimizedUrl = `${cloudfrontUrl}/${base64}`;

  return optimizedUrl;
};
